import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './component/layout/layout.component';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CoreModule } from './../core/core.module';
import { SharedModule } from './../shared/shared.module';
import { MenuComponent } from './component/menu/menu.component';
import { EventActionService } from '../shared/services/eventAction.service';

@NgModule({
  declarations: [LayoutComponent, MenuComponent],
  imports: [CommonModule, RouterModule, FlexLayoutModule, CoreModule, SharedModule],
  providers: [EventActionService]
})
export class LayoutModule {}
